const createAltTag = ({ variant, prefix }) => {
  return [prefix, variant.displayName].filter(Boolean).filter((entry) => entry != "").join(", ");
};
export {
  createAltTag
};
//# sourceMappingURL=create-alt-tag.js.map
